import { render, staticRenderFns } from "./HireMail.vue?vue&type=template&id=0988f416"
import script from "./HireMail.vue?vue&type=script&lang=js"
export * from "./HireMail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\BuildAgent\\work\\136\\s\\Yahome.RecruitSystem.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0988f416')) {
      api.createRecord('0988f416', component.options)
    } else {
      api.reload('0988f416', component.options)
    }
    module.hot.accept("./HireMail.vue?vue&type=template&id=0988f416", function () {
      api.rerender('0988f416', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/back/Modal/HireMail.vue"
export default component.exports